import { RESOURCES } from "../types/actions";

const initialState = {
	resourcesResult: [],
	searchedResources: [],
	selectedResource: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case RESOURCES.GET_RESOURCES:
			return {
				...state,
				resourcesResult: action.payload
			};
		case RESOURCES.GET_RESOURCE_DETAILS:
			return {
				...state,
				resourceDetails: action.payload
			};
		case RESOURCES.RESET_RESOURCES:
			return {
				...state,
				resourcesResult: initialState.resourcesResult
			};
		case RESOURCES.SEARCH_RESOURCES:
			return {
				...state,
				searchedResources: action.payload
			};
		case RESOURCES.SELECTED_RESOURCE:
			return {
				...state,
				selectedResource: action.payload
			};
		default:
			return state;
	}
};
